import { CINETY_DOMAIN } from "constant/config";

export const oRedirect = {
    'aforiginal' : CINETY_DOMAIN,
}
